var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container bg-white py-4 min-vh-100"},[_c('div',{staticClass:"text-center font-weight-bold"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),(_vm.content.content)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.contentHtml)}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }